<!--
Author: TangChen
Date: 2019-07-31
Desc: 基金知识详情，由router.js 配置引入
 -->
<template>
    <div class="bizcomp-know-detail bizcomp" :class="className">
        <comp-title :title="title"></comp-title>
        <div v-if="financeNew.title" class="info-con">
            <div class="tit" v-text="financeNew.title"></div>
            <div v-cloak class="other font-grey">
                <span v-if="!$util.isEmpty(financeNew.source)" class="read-num">来源：{{ financeNew.source }}</span>&nbsp;&nbsp;&nbsp;
                <span class="read-num">更新时间：{{ (financeNew.updatetime||financeNew.createtime).replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3") }}</span>
                <a v-if="!$util.isEmpty(financeNew.fileid)" style="margin-left:20px" :href="$util.src('/common/download', { id: financeNew.fileid })">附件<i class="main el-icon-bottom"></i></a>
            </div>
            <div v-if="!$util.isEmpty(financeNew.brief)" class="announce-text font-grey">
                摘要：{{ financeNew.brief }}
            </div>
            <div v-if="!$util.isEmpty(financeNew.content)" class="announce-text" v-html="financeNew.content">
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "KnowDetail",
    mixins: [mixin],
    data(){
        return{
            financeNew: {}
        };
    },
    computed: {
    },
    mounted () {
        this.getFinanceNew();
    },
    methods: {
        getFinanceNew(){
            const _this = this;
            this.$util.request("fund/notice/detail",{id: this.$route.query.id}).then(res => {
                if (res.data) {
                    _this.financeNew = res.data[0] || {};
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .bizcomp-know-detail {
        .info-con{
            padding: 20px 30px;
            .tit{
                font-size: 20px;
                line-height: 50px;
                text-align: center;
                border-bottom: 1px dashed #cfcfcf;
            }
            .other{text-align: center;line-height: 36px;padding-top: 10px;}
            .announce-text{padding-bottom: 15px;padding-top: 15px;text-indent: 2rem;}
        }
    }
</style>
